import React from 'react';

import { defineMessages } from 'react-intl.macro';
import { Typography } from '@material-ui/core';
import { isUndefined } from 'lodash';
import { ErrorBoundary as ReactErrorBoundary, FallbackProps } from 'react-error-boundary';

import { Button } from 'components/v2';
import FormattedSimpleMessage from '../FormattedSimpleMessage';

const messages = defineMessages({
  errorMessage: {
    id: '@lib.core.ErrorBoundary.errorMessage',
    defaultMessage: 'Something went wrong, please refresh the page.',
  },
  retry: {
    id: '@lib.core.ErrorBoundary.retry',
    defaultMessage: 'Try again',
  },
});

type ReactErrorBoundaryProps = {
  fallback?: React.ReactElement | null;
  fallbackRender?: (props: FallbackProps) => React.ReactElement;
  FallbackComponent?: React.ComponentType;
  onResetKeysChange?: (prevResetKeys: Array<unknown> | undefined, resetKeys: Array<unknown> | undefined) => void;
  onReset?: (...args: Array<unknown>) => void;
  onError?: (
    error: Error,
    info: {
      componentStack: string;
    },
  ) => void;
  resetKeys?: Array<unknown>;
  withRetryButton?: boolean;
};

const ErrorBoundary: React.FC<ReactErrorBoundaryProps> = ({ children, fallback, withRetryButton, ...props }) => {
  const fallbackRender = ({ resetErrorBoundary, error }: { resetErrorBoundary: () => void; error: Error }) => (
    <div className="error-screen">
      {isUndefined(fallback) ? (
        <>
          <FormattedSimpleMessage {...messages.errorMessage} />
          <Typography variant="caption">{error && error.message}</Typography>
        </>
      ) : (
        fallback
      )}
      {withRetryButton && (
        <>
          <br />
          <Button variant="contained" rounded color="primary" onClick={resetErrorBoundary}>
            <FormattedSimpleMessage {...messages.retry} />
          </Button>
        </>
      )}
    </div>
  );

  return (
    // @ts-ignore
    <ReactErrorBoundary fallbackRender={fallbackRender} {...props}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
